export default __webpack_public_path__ + "static/media/timepass.0cebe7af.svg";